module.exports = __webpack_public_path__ + "static/c9-8ac7986385c29a218bd7d09a560e3615.png";